export const isMobile = () => {
    return window.innerWidth < 1024;
};

export const fileName = (file = '') => {
    file = file ? file.replace(/\\/g, '/') : '';
    return file ? file.substr(file.lastIndexOf('/') + 1) : file;
};

export const imageSrc = (picture = '') => {
    return picture ? `${process.env.VUE_APP_API_URL_PREFIX}${window.location.hostname.replace('admin.', '')}${process.env.VUE_APP_STATIC_URL_POSTFIX}/${ picture.replace(/\\/g, '/') }` : '';
};

export const checkUserProfile = (user = {}) => {
    return (user._id && user.firstname && user.lastname && user.avatar && user.about);
};

export const priceFormated = (price, currency) => {
    return new Intl.NumberFormat('ru-RU').format(price) 
    + {
        'EUR': '&#8364;', 
        'USD': '&#36;',
        'RUB': '&#8381;',
    }[currency]
};

export const translit = (word = {}) => {
    var converter = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
        'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
        'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
        'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
        'э': 'e', 'ю': 'yu', 'я': 'ya'
    };

    word = word.trim().toLowerCase();

    var answer = '';
    for (var i = 0; i < word.length; ++i ) {
        if (converter[word[i]] == undefined){
            answer += word[i];
        } else {
            answer += converter[word[i]];
        }
    }

    answer = answer.replace(/[^-0-9a-z]/g, '-');
    answer = answer.replace(/^\-|-$/g, '-'); 
    answer = answer.replace(/[-]+/g, '-');
    answer = answer.replace(/\-/g, ' ');
    answer = answer.trim();
    answer = answer.replace(/ /g, '-');
    return answer;
};

export const generateCode = length => {
    const allowedValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var code = '';
    for (var i = 0; i < length; i++) {
        code += allowedValues[getRand(allowedValues.length)];
    }
    return code;
}

const getRand =  max => {
    return Math.floor(Math.random() * max);
}